import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import EmpLayout from "./emp_layout";
import { API_ENDPOINTS } from "../../api/config";
import './css/my_listings.css';

const pillMap = { active: "pill-active", paused: "pill-paused", closed: "pill-closed" };
const FILTERS = ["All", "Active", "Paused", "Closed"];

export default function MyListings() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState("All");
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMyListings();
  }, []);

  const fetchMyListings = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(API_ENDPOINTS.MYLISTINGS, {
        headers: { "Authorization": `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setListings(data);
      }
    } catch (err) {
      console.error("Failed to load listings", err);
    } finally {
      setLoading(false);
    }
  };

  const toggleStatus = async (id, newStatus) => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(`${API_ENDPOINTS.UPDATESTATUS}/${id}`, {
        method: "PATCH",
        headers: { 
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}` 
        },
        body: JSON.stringify({ status: newStatus })
      });
      if (res.ok) {
        setListings(prev => prev.map(l => l.id === id ? { ...l, status: newStatus } : l));
      }
    } catch (err) {
      console.error("Status update failed", err);
    }
  };

  const filtered = filter === "All" ? listings : listings.filter(l => l.status?.toLowerCase() === filter.toLowerCase());

  if (loading) return <EmpLayout title="My" titleEm="Listings"><div className="ml-loading">Loading your listings...</div></EmpLayout>;

  return (
    <EmpLayout title="My" titleEm="Listings">
      <div className="ml-stats-row">
        {[
          ["Total", listings.length],
          ["Active", listings.filter(l => l.status?.toLowerCase() === "active").length],
          ["Applicants", listings.reduce((s, l) => s + (l.applicationCount || 0), 0)],
          ["Views", listings.reduce((s, l) => s + (l.viewCount || 0), 0)]
        ].map(([k, v]) => (
          <div key={k} className="ml-stat"><div className="ml-stat-n">{v}</div><div className="ml-stat-l">{k}</div></div>
        ))}
      </div>

      <div className="ml-filter-row">
        {FILTERS.map(f => <button key={f} className={`ml-filter-btn${filter === f ? " active" : ""}`} onClick={() => setFilter(f)}>{f}</button>)}
      </div>

      {filtered.length === 0 ? (
        <div className="ml-empty">
          <div className="ml-empty-icon">📋</div>
          <div className="ml-empty-title">No {filter !== "All" ? filter.toLowerCase() : ""} listings found</div>
          <button className="emp-btn-primary" onClick={() => navigate("/employer/post-job")}>+ Post a Job</button>
        </div>
      ) : (
        <div className="ml-list">
          {filtered.map(l => (
            <div key={l.id} className="ml-card">
              <div className="ml-card-top">
                <div className="ml-icon">💼</div>
                <div className="ml-info">
                  <div className="ml-title">{l.title}</div>
                  <div className="ml-meta">
                    Posted {l.createdAt ? new Date(l.createdAt).toLocaleDateString() : "Recent"} · {l.jobType} · {l.city}
                  </div>
                </div>
                <span className={pillMap[l.status?.toLowerCase() || "active"]}>{l.status}</span>
              </div>
              <div className="ml-divider" />
              <div className="ml-bottom">
                <div className="ml-stats">
                  {[["Applicants", l.applicationCount || 0], ["Views", l.viewCount || 0]].map(([k, v]) => (
                    <div key={k} className="ml-stat-mini">
                      <div className="ml-stat-mini-n">{v}</div>
                      <div className="ml-stat-mini-l">{k}</div>
                    </div>
                  ))}
                </div>
                <div className="ml-actions">
                  {/* Redirects to JobDetailsView via App Route configuration */}
                  <button type="button" className="ml-btn primary" onClick={() => navigate(`/employer/listing-details/${l.id}`)}>View Details</button>
                  {l.status?.toLowerCase() === "active" && <button className="ml-btn ghost" onClick={() => toggleStatus(l.id, "paused")}>Pause</button>}
                  {l.status?.toLowerCase() === "paused" && <button className="ml-btn ghost" onClick={() => toggleStatus(l.id, "active")}>Resume</button>}
                  {l.status?.toLowerCase() !== "closed" && <button className="ml-btn danger" onClick={() => toggleStatus(l.id, "closed")}>Close</button>}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </EmpLayout>
  );
}